
import Vue from 'vue'

export default Vue.extend({
    data: () => {
        return {
            block: null as Connex.Thor.Block | null,
            error: null as Error | null,
            id: ''
        }
    },
    computed: {
        txs() { return this.block!.transactions },
        // tslint:disable-next-line:no-bitwise
        vip191Supported() { return !!(((this.block as any).txsFeatures || 0) & 1) },
        finalized() { return !!(this.block as any).isFinalized }
    },
    methods: {
        async reload() {
            this.block = null
            this.error = null

            try {
                const block = await this.$connex.thor.block(this.id).get()
                if (!block) {
                    this.error = new Error('block not found')
                } else {
                    this.block = block
                }
            } catch (err) {
                this.error = err as Error
            }
        }
    },
    created() {
        this.$ga.page('/insight/block')
        this.id = this.$route.params.id
        this.reload()
    }
})
